let $localSearchMap = $('#map');
let $singleOfferMap = $('#singleOfferMap');

let myStyles = [
    {
        featureType: "poi",
        elementType: "labels",
        stylers: [
            {
                visibility: "off"
            }
        ]
    }
];

let markers, bounds, infoWindow, map, markerCluster, lat, lng, coords;

window.initMap = function() {
    if ($localSearchMap.length > 0) {
        let latitude = $('#lat').val();
        let longitude = $('#lng').val();

        if (latitude === '' || longitude === '') {
            return;
        }

        //  from initial page load
        lat = parseFloat(latitude);
        lng = parseFloat(longitude);

        //  make google maps friendly
        coords = {lat: lat, lng: lng};

        bounds = new google.maps.LatLngBounds();
        infoWindow = new google.maps.InfoWindow();

        map = new google.maps.Map($localSearchMap[0], {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: coords,
            zoom: 12,
            styles: myStyles
        });

        // should we add a marker for the searched location? - do this only once per page load
        addSearchedMarker(coords);

        google.maps.event.addListener(map, 'idle', function () {
            let center = this.getCenter();
            $('#lat').val(center.lat());
            $('#lng').val(center.lng());

            // some events do not require a reload of data (eg. infoWindow popup that moves the map)
            if (parseInt($('#redraw').val()) === 1) {
                submitRequest();
            }

            //  in case we set not to redraw last time around, set it back to true
            $('#redraw').val(1);
        });
    }

    if ($singleOfferMap.length > 0) {
        let latitude = $('#lat').val();
        let longitude = $('#lng').val();

        if (latitude === '' || longitude === '') {
            return;
        }

        //  from initial page load
        lat = parseFloat(latitude);
        lng = parseFloat(longitude);
        //  make google maps friendly
        coords = {lat: lat, lng: lng};

        bounds = new google.maps.LatLngBounds();
        infoWindow = new google.maps.InfoWindow();

        map = new google.maps.Map($singleOfferMap[0], {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: coords,
            zoom: 12,
            styles: myStyles
        });

        submitRequest();
    }
}

/**
 * This is the searched location that stays the same until another search is performed
 * @param {*} coords
 */
function addSearchedMarker(coords) {
    //  create and add marker to show where the user searched
    let searched = new google.maps.Marker({
        position: coords
    });
    searched.setMap(map);
}

function updateMap(response) {

    if (parseInt($('#redraw').val()) === 0) {
        map.setCenter({lat: parseFloat($('#lat').val()), lng: parseFloat($('#lng').val())});
    }

    if (markers !== undefined) {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
    }

    bounds = new google.maps.LatLngBounds();

    let locationsArray = response.locations

    // sneaky call to show hide zero results alert
    if (locationsArray.length === 0) {
        //alert('Sorry, it seems there are no offers in the immediate vicinity. Try zooming out by clicking the (minus) sign on the map.');
    }

    let coordinates;

    markers = locationsArray.map(function (location, i) {
        coordinates = {lat: parseFloat(location.latitude), lng: parseFloat(location.longitude)};

        let icon = {
            url: (location.marker !== undefined) ? location.marker : null, // url
            /*scaledSize: new google.maps.Size(60, 60), // scaled size*/
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
        };

        let marker = new google.maps.Marker({
            position: coordinates,
            icon: icon
        });

        google.maps.event.addListener(marker, 'click', (function (marker) {
            let temp = location;
            let $offerHtml = '';

            $.each( temp.offers, function( index, offer ) {
                $offerHtml += '<div class="offer-description">\
                    <a href="' + offer.url + '">\
                        <h3>' + offer.title + '</h3>\
                        <p>' + offer.sub_title + '</p>\
                    </a>\
                    <hr style="border-top: 1px solid #fafafa;">\
                    <p style="margin-top: 5px">' + offer.address + '</p>\
                    <p style="margin-top: 5px">' + (offer.phone === '' ? '' : ('Tel: ' + offer.phone)) + '</p>\
                    <a href="' + offer.url + '" style="font-size: 18px; font-weight: 700; text-decoration: underline; margin-top: 10px;">View Offer</a>\
                </div>';
            });

            return function () {
                let content = '<div class="map-offer">\
                    <div class="offer-block layout-one" style="width: 252px; height: auto;">\
                        <div class="offer-main-image" style="background: url("#") center no-repeat; background-size: cover;">\
                            <div style="max-width: 250px; width: 100%; position: absolute; left: 0; top: 0; height: 121px;">\
                                <img src="' + location.listing + '" style="width:100%; height: auto;" alt="">\
                            </div>\
                        </div>\
                        <div class="offer-logo">\
                            <div class="img-frame">\
                                <img style="max-width: 100%;" src="' + location.logo + '" class="img-fluid" alt="">\
                            </div>\
                        </div>'
                        + $offerHtml +
                    '</div>\
                </div>';

                infoWindow.setContent(content);
                infoWindow.open(map, marker);
                $('#redraw').val(0);
            }
        })(marker, i));

        return marker;
    });

    for (let l = 0; l < markers.length; l++) {
        markers[l].setMap(map);
    }
}

function updateOfferMap(response) {
    let locationsArray = response.locations
    let coordinates;
    let locationList = '';

    markers = locationsArray.map(function (location, i) {
        let letter = String.fromCharCode("A".charCodeAt(0) + i);
        coordinates = {lat: parseFloat(location.latitude), lng: parseFloat(location.longitude)};
        let position = new google.maps.LatLng(location.latitude, location.longitude);

        let marker = new google.maps.Marker({
            position: coordinates,
            label: letter
        });

        let $html = '<div class="row location"><div class="col-md-12"><div class="wrap"><p><span>' +letter+ '</span> ' +location.partner.name+ '</p><p class="addr">' +location.address+ '</p></div></div></div></div>';

        google.maps.event.addListener(marker, 'click', (function (marker) {
            let temp = location;
            return function () {
                let content = temp.address;
                infoWindow.setContent(content);
                infoWindow.open(map, marker);
            }
        })(marker, i));

        locationList += $html;

        bounds.extend(position);

        return marker;
    });

    map.fitBounds(bounds);

    $('#locationList').html(locationList);

    for (let l = 0; l < markers.length; l++) {
        markers[l].setMap(map);
    }
}

function throttle(mainFunction, delay) {
    let timerFlag = null; // Variable to keep track of the timer

    // Returning a throttled version
    return (...args) => {
        if (timerFlag === null) { // If there is no timer currently running
            mainFunction(...args); // Execute the main function
            timerFlag = setTimeout(() => { // Set a timer to clear the timerFlag after the specified delay
                timerFlag = null; // Clear the timerFlag to allow the main function to be executed again
            }, delay);
        }
    };
}

const submitRequest = throttle(callSubmitRequest, 1000);


/**
 * used to get data from the server and update the map and filters
 */
function callSubmitRequest() {
    $('#loading-map').show();
    axios.post('/a/local-lookup', {
        search: cleanseSearch($('#location').val()),
        type: $('#type').val(),
        latitude: parseFloat($('#lat').val()),
        longitude: parseFloat($('#lng').val()),
        partner: parseFloat($('#partner').val()),
        limit: parseFloat($('#limit').val()),
        radius: parseFloat($('#radius').val()),
    }).then(function (response) {
        let data = response.data[0];
        $('#lat').val(data.latitude);
        $('#lng').val(data.longitude);

        //update map and icons
        if ($localSearchMap.length > 0) {
            updateMap(data);
        } else {
            updateOfferMap(data);
        }

        //update filters
        $('.map-filters').html(data.filters);
        //hide loading block
        $('#loading-map').hide();
    })
    return true;
}

$(document).on("click", ".single-location", function() {
    google.maps.event.trigger(markers[$(this).data('marker-id')], 'click');
});

$(document).on("click", ".item-parent", function() {
    $('#type').val($(this).data('type'));
    submitRequest();
});

$(document).on("click", ".js-search", function() {
    $('#redraw').val(0);
    submitRequest();
});

$('#location').on('keypress', function (e) {
    if(e.which === 13){
        $('.location-str').html(cleanseSearch($(this).val()));
        $('#redraw').val(0);
        $('#location-search-subheading')[0].innerHTML = "Showing local offers within 20 miles of " + $('#location')[0].value + ".";
        submitRequest();
    }
});
